<template>
    <div v-if="src !== 'under_construction'" class="tw-hidden sm:tw-flex">
        <iframe
            height="100%"
            width="100%"
            :src="src"
        ></iframe>
    </div>
    <div v-else class="tw-hidden sm:tw-flex tw-flex tw-justify-center tw-items-center tw-text-xl" style="background-color: lightgrey">
        Website Under Construction
    </div>

</template>

<script>

export default {
    name: "LinkPreviewComponent",
    props: {
        'src': {
            type: String,
            required: true,
        },
        'width': {
            type: String,
            required: false,
            default: 'auto'
        },
        'height': {
            type: String,
            required: false,
            default: 'auto'
        }
    },
    data() {
        return {
            dialog: this.value || false,
        }
    },
    methods: {
        goToWebsite() {
            window.open(this.src, '_blank')
            this.dialog = false
        }
    },
}
</script>

<style scoped>

</style>
